<template>
  <div class="media_page" >
    <Page title="增值服务" :showBottom="false">
      <div class="tab-line">
        <div
          class="tab-item"
          @click="hugItemBtn(1)"
          :class="{ active: topSelect == 1 }"
          :style="{
            color: topSelect == 1 ? changeColor : '',
            'border-top': topSelect == 1 ? '2px solid ' + changeColor : '',
          }"
        >
          <div
            v-if="topSelect == 1"
            style="
              position: absolute;
              height: 2px;
              width: 130px;
              background-color: #fff;
              margin-top: 34px;
            "
          ></div>
          增值服务订购
        </div>
        <div
          class="tab-item"
          @click="hugItemBtn(2)"
          :class="{ active: topSelect == 2 }"
          :style="{
            color: topSelect == 2 ? changeColor : '',
            'border-top': topSelect == 2 ? '2px solid ' + changeColor : '',
          }"
        >
          <div
            v-if="topSelect == 2"
            style="
              position: absolute;
              height: 2px;
              width: 130px;
              background-color: #fff;
              margin-top: 34px;
            "
          ></div>
          订购记录
        </div>
      </div>
      <buy v-if="topSelect == 1"></buy>
      <record v-else-if="topSelect == 2"></record>
    </Page>
  </div>
</template>

<script>
import Page from "@/components/common/myPage.vue";
import buy from "./buy.vue";
import record from "./record.vue";

import { mapState, mapMutations } from "vuex";

export default {
  components: {
    Page,
    buy,
    record,
  },
  data: function () {
    return {
      topSelect:1,
    };
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
  },
  created() {
    // 埋点
    this.buriedPoint(1, '增值服务', '后台管理', '增值服务')
  },
  mounted() {
    // this.init();
  },
  methods: {
    hugItemBtn(type) {
      this.topSelect = type;
    }
  },
};
</script>

<style lang="scss" scoped>

.tab-line {
    font-size: 14px;
    color: #666;
    border-bottom: 1px solid #dddddd;
    margin-bottom: 20px;
    .tab-item {
      text-align: center;
      width: 130px;
      height: 36px;
      line-height: 36px;
      display: inline-block;
      position: relative;
      cursor: pointer;
      margin-right: 2px;
      border: 1px solid #dddddd;
      border-bottom: none;
      span {
        position: absolute;
        width: 100%;
        left: 50%;
        height: 2px;
        transform: translateX(-50%);
        bottom: -2px;
        display: none;
      }
      &.active {
        border-top: 2px;
        span {
          display: block;
          background: #fff;
        }
      }
    }
  }

</style>

